import { render, staticRenderFns } from "./SamSearch.vue?vue&type=template&id=ce297e34&scoped=true&"
import script from "./SamSearch.vue?vue&type=script&lang=js&"
export * from "./SamSearch.vue?vue&type=script&lang=js&"
import style0 from "./SamSearch.vue?vue&type=style&index=0&id=ce297e34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce297e34",
  null
  
)

export default component.exports